import { RiskStepDef } from '@webapp/risk-core';
import { IActivarStep } from '@webapp/ui';

const DEFAULT_STEP_NAMES = ['Datos del usuario', 'Resumen', 'Medio de pago'] as const;

/**
 * Issue-policy stepper for a risk: only the first step is selectable up front,
 * unless the plugin marks a later one `enabled`. Risks that declare no steps get
 * the default three.
 */
export function buildIssuePolicySteps(steps: readonly RiskStepDef[]): IActivarStep[] {
  const defs: readonly Pick<RiskStepDef, 'name' | 'enabled'>[] = steps.length
    ? steps
    : DEFAULT_STEP_NAMES.map((name) => ({ name }));

  return defs.map((step, index) => ({
    id: index + 1,
    name: step.name,
    active: index === 0,
    disabled: index !== 0 && step.enabled !== true,
    completed: false,
  }));
}
